import type { ListingDataTableColumn } from "../components/listing-data-table";
import type { RankingListItem } from "../types/ranking";

export const RANKING_BY_DRIVER_COLUMNS: ListingDataTableColumn<RankingListItem>[] =
	[
		{ id: "name", label: "Motoristas", minWidth: 168 },
		{ id: "plate", label: "Placa", minWidth: 112 },
		{ id: "model", label: "Modelo", minWidth: 160 },
		{
			id: "predominantEventType",
			label: "Tipo de Evento Predominante",
			minWidth: 200,
		},
		{
			id: "totalEvents",
			label: "Total de Eventos",
			minWidth: 140,
			sortable: true,
		},
		{
			id: "riskEvents",
			label: "Risco de Eventos",
			minWidth: 140,
			sortable: true,
		},
		{
			id: "riskPercentage",
			label: "% de Risco",
			minWidth: 120,
			sortable: true,
		},
	];

export const RANKING_BY_VEHICLE_COLUMNS: ListingDataTableColumn<RankingListItem>[] =
	[
		{ id: "plate", label: "Placa", minWidth: 112 },
		{ id: "model", label: "Modelo", minWidth: 160 },
		{
			id: "predominantEventType",
			label: "Tipo de Evento Predominante",
			minWidth: 200,
		},
		{
			id: "totalEvents",
			label: "Total de Eventos",
			minWidth: 140,
			sortable: true,
		},
		{
			id: "riskEvents",
			label: "Risco de Eventos",
			minWidth: 140,
			sortable: true,
		},
		{
			id: "riskPercentage",
			label: "% de Risco",
			minWidth: 120,
			sortable: true,
		},
	];

export const RANKING_SORT_BY_MAP: Record<string, string> = {
	totalEvents: "totalEvents",
	riskEvents: "riskevents",
	riskPercentage: "riskpercentage",
};
